import { useEffect } from 'react';
import { getUserAvatarFbMethod, removeUserAvatarFbMethod } from '../../../util/localStorage';
import { allowedStrategies } from '../helpers';
/**
 * There are 2 strategies that may be pre-saved:
 * "insta-pic" and "facebook-pic"
 *
 * We pre-save a strategy and reload the page to reboot
 * fb sdk access token with certain permissions
 */
export const useSessionStorageInitialStrategy = ({ setStrategy }) => {
    useEffect(() => {
        const { strategy } = getUserAvatarFbMethod() || {};
        const isAllowed = allowedStrategies.includes(strategy);

        removeUserAvatarFbMethod();

        if (!strategy) return;
        if (!isAllowed) return;

        setStrategy(strategy);
    }, []);
};
